/* Product Gallery Pro - prev/next arrows drive Dawn's thumbnail navigation */
(function () {
  function getVisibleThumbs(gallery) {
    return Array.from(gallery.querySelectorAll('.thumbnail-list__item')).filter(function (li) {
      return !li.hidden && li.offsetParent !== null;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pgp-arrow]');
    if (!btn) return;
    e.preventDefault();

    var gallery = btn.closest('media-gallery');
    if (!gallery) return;

    var thumbs = getVisibleThumbs(gallery);
    if (thumbs.length < 2) return;

    var index = thumbs.findIndex(function (li) {
      return li.querySelector('.thumbnail[aria-current="true"]');
    });
    if (index < 0) index = 0;

    var dir = btn.dataset.pgpArrow === 'next' ? 1 : -1;
    var target = thumbs[(index + dir + thumbs.length) % thumbs.length];
    var thumbBtn = target.querySelector('.thumbnail');
    if (thumbBtn) thumbBtn.click();
  });
})();